module.exports = __webpack_public_path__ + "8a63d920c39db46b89f533f9cbd25a70.pdf";